(function(){
  if ( 'ontouchstart' in window ) return;
  if ( window.AzeoCursorDotInit ) return;
  window.AzeoCursorDotInit = true;

  var EXCLUDE_SELECTOR = '.product-item__image, .product-gallery-item[data-product-media-type="image"], .product-gallery-item__zoom';
  var INVERT_SELECTOR = '.main-footer';
  var ROTATE = 'rotate(135deg)';
  var CURSOR_COLOR = '#2E2E2E';
  var CURSOR_COLOR_INVERTED = '#FFFFFF';
  var DROPLET_COLOR = '#EFECE6';

  var style = document.createElement('style');
  style.textContent = ''
    + '.azeo-cursor-dot{position:fixed;top:0;left:0;width:10px;height:10px;border-radius:50% 50% 50% 0;background:' + CURSOR_COLOR + ';pointer-events:none;z-index:99999;opacity:0;transform:translate3d(-999px,-999px,0) ' + ROTATE + ';will-change:transform;transition:opacity 250ms ease,background-color 150ms ease;}'
    + '.azeo-cursor-dot.is-visible{opacity:1;}'
    + '.azeo-cursor-dot.is-inverted{background:' + CURSOR_COLOR_INVERTED + ';box-shadow:0 0 0 1px rgba(0,0,0,.25);}'
    + '@keyframes azeoSplash{0%{transform:translate3d(0,0,0) scale(1) ' + ROTATE + ';opacity:1;}100%{transform:translate3d(var(--dx),var(--dy),0) scale(.15) ' + ROTATE + ';opacity:0;}}'
    + '.azeo-splash-drop{position:fixed;top:0;left:0;width:6px;height:6px;border-radius:50% 50% 50% 0;background:' + DROPLET_COLOR + ';box-shadow:0 0 0 1px rgba(46,46,46,.15);pointer-events:none;z-index:99999;animation:azeoSplash 520ms cubic-bezier(.25,.8,.35,1) forwards;}'
    + '@media (prefers-reduced-motion: reduce){.azeo-cursor-dot,.azeo-splash-drop{display:none;}}';
  document.head.appendChild(style);

  var dot = document.createElement('div');
  dot.className = 'azeo-cursor-dot';
  dot.setAttribute('aria-hidden', 'true');
  document.body.appendChild(dot);

  var mouseX = -999, mouseY = -999;
  var posX = -999, posY = -999;
  var visible = false;
  var suppressed = false;
  var inverted = false;
  var ease = 0.18; /* plus petit = plus de retard/smooth, plus grand = plus reactif */
  var running = false; /* Azéo perf : la boucle d'animation ne tourne que pendant que la souris bouge */

  function show(){
    if ( visible || suppressed ) return;
    visible = true;
    dot.classList.add('is-visible');
  }

  function hide(){
    if ( ! visible ) return;
    visible = false;
    dot.classList.remove('is-visible');
  }

  function invert(){
    if ( inverted ) return;
    inverted = true;
    dot.classList.add('is-inverted');
  }

  function uninvert(){
    if ( ! inverted ) return;
    inverted = false;
    dot.classList.remove('is-inverted');
  }

  function start(){
    if ( running ) return;
    running = true;
    window.requestAnimationFrame(loop);
  }

  document.addEventListener('mousemove', function(e){
    mouseX = e.clientX;
    mouseY = e.clientY;
    if ( ! visible && ! suppressed ) {
      posX = mouseX;
      posY = mouseY;
      show();
    }
    start();
  }, { passive: true });

  document.addEventListener('mouseleave', function(){
    hide();
  });

  /* desactive le curseur quand on survole les images produits (fiche produit + liste produits),
     qui ont deja leur propre curseur personnalise */
  document.addEventListener('mouseover', function(e){
    var target = e.target.closest ? e.target.closest(EXCLUDE_SELECTOR) : null;
    if ( target ) {
      suppressed = true;
      hide();
    }

    /* passe le curseur en blanc sur les zones a fond sombre (ex: footer) */
    var invertTarget = e.target.closest ? e.target.closest(INVERT_SELECTOR) : null;
    if ( invertTarget ) {
      invert();
    }
  });

  document.addEventListener('mouseout', function(e){
    if ( suppressed ) {
      var target = e.target.closest ? e.target.closest(EXCLUDE_SELECTOR) : null;
      if ( target && ( ! e.relatedTarget || ! target.contains(e.relatedTarget) ) ) {
        suppressed = false;
        show();
      }
    }

    if ( inverted ) {
      var invertTarget = e.target.closest ? e.target.closest(INVERT_SELECTOR) : null;
      if ( invertTarget && ( ! e.relatedTarget || ! invertTarget.contains(e.relatedTarget) ) ) {
        uninvert();
      }
    }
  });

  /* eclaboussure au clic : la goutte principale "explose" en 3 petites gouttelettes qui partent en eventail */
  function spawnSplash(x, y){
    var baseAngles = [-150, -90, -30];
    baseAngles.forEach(function(baseAngle){
      var angle = (baseAngle + (Math.random() * 24 - 12)) * Math.PI / 180;
      var distance = 16 + Math.random() * 12;
      var dx = Math.cos(angle) * distance;
      var dy = Math.sin(angle) * distance;

      var drop = document.createElement('div');
      drop.className = 'azeo-splash-drop';
      drop.style.left = (x - 3) + 'px';
      drop.style.top = (y - 3) + 'px';
      drop.style.setProperty('--dx', dx.toFixed(1) + 'px');
      drop.style.setProperty('--dy', dy.toFixed(1) + 'px');
      document.body.appendChild(drop);

      var cleanup = function(){ if ( drop.parentNode ) drop.parentNode.removeChild(drop); };
      drop.addEventListener('animationend', cleanup);
      window.setTimeout(cleanup, 650);
    });
  }

  document.addEventListener('click', function(e){
    spawnSplash(e.clientX, e.clientY);
  });

  function loop(){
    posX += (mouseX - posX) * ease;
    posY += (mouseY - posY) * ease;
    /* goutte arrivee sur la souris : on se cale dessus et on arrete la boucle jusqu'au prochain mouvement */
    if ( Math.abs(mouseX - posX) < 0.1 && Math.abs(mouseY - posY) < 0.1 ) {
      posX = mouseX;
      posY = mouseY;
      running = false;
    }
    dot.style.transform = 'translate3d(' + (posX - 5) + 'px, ' + (posY - 5) + 'px, 0) ' + ROTATE;
    if ( running ) window.requestAnimationFrame(loop);
  }
})();
